export const isAuthenticated = state => {
	return state.client.authenticated || (state.client.token != undefined && state.client.token) === (localStorage.getItem('client') && JSON.parse(localStorage.getItem('client')).token);	
}
export const getOrganization = state => state.organization || {};


